import { convertLooksToEth } from "../../utils";

export const getTotalEth = (ethAmount: bigint, looksAmount: bigint, ethPriceUsd: number, looksPriceUsd: number) => {
  return ethAmount + convertLooksToEth(looksAmount, ethPriceUsd, looksPriceUsd);
};
